<template>
  <div>
    <v-container grid-list-xl fluid>
      <v-layout justify-center>
        <v-flex lg12>
          <v-card>
            <template>
              <grid-centro
                :key="gridDocumento"
                :rowsTable="rowsTable"
              ></grid-centro>
            </template>
            <v-card-actions class="pb-3">
              <v-spacer></v-spacer>
              <v-btn
                :loading="loading"
                color="primary"
                dark
                class="mb-2"
                @click="downloadCenter()"
                >Descargar Centros</v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
      <v-dialog v-model="dialogLoading" persistent max-width="390">
        <loading-descarga></loading-descarga>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import GridCentro from "@/modules/aplicacion/views/centros/GridCentro.vue";
import LoadingDescarga from "@/views/ui/LoadingDescarga.vue";

export default {
  name: "centro",

  components: {
    GridCentro,
    LoadingDescarga,
  },

  props: {
    tabSelected: "",
  },

  data() {
    return {
      dialogLoading: false,
      loading: false,
      proveedor: {},
      rowsTable: [20],
      contratoId: "",
      tabSelect: "",
      activeTab: "",
      index: "",
      rowsPerPageItems: [20],
      pagination: {
        rowsPerPage: 20,
      },
      filter: false,
      usuarioLogged: "",
      gridDocumento: 20,
      idEstado: "",
      tipeCenter: "",
      contratoId: "",
    };
  },
  watch: {
    dialogLoading(val) {
      if (!val) return;

      setTimeout(() => (this.dialogLoading = false), 4000);
    },
  },
  mounted() {
    this.usuarioLogged = this.$store.getters.userLogged;
    this.tipeCenter = this.$store.getters.subTabSelectedStored;
    this.contratoId = this.$store.getters.contratoStored;
  },
  created() {},

  methods: {
    reloadDocumento() {
      this.gridDocumento += 22;
    },

    selected(tab) {
      this.tabSelect = tab;
    },

    filterDoc() {
      this.filter = true;
    },

    downloadCenter() {
      let filename = "Centros_" + this.tipeCenter + ".xls";

      axios({
        url: "/centro/download/" + this.tipeCenter + "/" + this.contratoId,
        method: "GET",
        responseType: "blob",
      })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
  },
};
</script>
